export function handleError(error: any, errorMessage: string, replacedMessage: string): string | null {
    const originalMessage = error?.data?.originalError?.message || error?.message;

    if (originalMessage && originalMessage.includes(errorMessage)) {
        return replacedMessage;
    }
    return null;
}
